// extracted by mini-css-extract-plugin
export var navbarSubLink = "V_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "V_w1 d_f0 d_dB";
export var subPageLink = "V_gf d_gf";
export var burger = "V_w4";
export var sublinkSize = "V_w5";
export var linkSize = "V_w6";
export var Link = "V_tk z_tk z_sx z_sS";